import React from "react";
import PropTypes from "prop-types";
import { formatPrice, offsetByTicks } from "../../utils/priceUtils";

const toneOf = (entry) => entry.side;

const describe = (entry) => {
  if (entry.kind === "loss") return "Perda";
  if (entry.kind === "profit") return "Ganho";
  if (entry.side === "buy") return "Compra";
  if (entry.side === "sell") return "Venda";
  return "Ordem";
};

/**
 * Content of the stacked-orders overlay — one row per order/leg sharing a
 * price, with ±1-tick steppers and a cancel button (orders only). Rendered
 * inside a PrimeReact OverlayPanel anchored to the aggregate price cell.
 */
const BookOrderStackPanel = ({ symbol, price, entries, onMove, onCancel }) => {
  const move = (entry, ticks) => {
    const next = offsetByTicks(symbol, entry.price, ticks);
    if (!Number.isFinite(next)) return;
    onMove?.([
      {
        orderId: entry.orderId,
        otoOrderId: entry.otoOrderId || undefined,
        price: next,
      },
    ]);
  };

  return (
    <div className="bbp-stack-panel">
      <div className="bbp-stack-panel__header">
        {formatPrice(symbol, price)} · {entries.length} ordens
      </div>
      {entries.map((entry) => (
        <div
          key={entry.id}
          className={`bbp-stack-panel__row bbp-stack-panel__row--${toneOf(entry)}`}
        >
          <span className="bbp-stack-panel__label">{entry.label}</span>
          <span className="bbp-stack-panel__desc">{describe(entry)}</span>
          <span className="bbp-stack-panel__price">
            {formatPrice(symbol, entry.price)}
          </span>
          <button
            type="button"
            className="bbp-stack-panel__step"
            title="Subir 1 tick"
            aria-label="Subir 1 tick"
            data-evo-id="bookbypricepanel-stack-step-up"
            onClick={() => move(entry, 1)}
          >
            ▲
          </button>
          <button
            type="button"
            className="bbp-stack-panel__step"
            title="Baixar 1 tick"
            aria-label="Baixar 1 tick"
            data-evo-id="bookbypricepanel-stack-step-down"
            onClick={() => move(entry, -1)}
          >
            ▼
          </button>
          {entry.kind === "order" ? (
            <button
              type="button"
              className="bbp-stack-panel__cancel"
              title="Cancelar ordem"
              aria-label="Cancelar ordem"
              data-evo-id="bookbypricepanel-stack-cancel"
              onClick={() => onCancel?.(entry)}
            >
              ×
            </button>
          ) : (
            <span
              className="bbp-stack-panel__cancel-spacer"
              aria-hidden="true"
            />
          )}
        </div>
      ))}
    </div>
  );
};

BookOrderStackPanel.propTypes = {
  symbol: PropTypes.string,
  price: PropTypes.number,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      kind: PropTypes.string.isRequired,
      orderId: PropTypes.string,
      otoOrderId: PropTypes.string,
      price: PropTypes.number,
      side: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  onMove: PropTypes.func,
  onCancel: PropTypes.func,
};

BookOrderStackPanel.defaultProps = {
  entries: [],
};

export default BookOrderStackPanel;
